import MainEventList from "../components/event-list/main-event-list";

function EventMasterList() {
  return (
    <div className="w-[97%] mx-auto">
        
      <MainEventList />
    </div>
  );
}

export default EventMasterList;
